// extracted by mini-css-extract-plugin
export var close = "CodeBlock-module--close--0ouW7";
export var minimize = "CodeBlock-module--minimize--TtT6T";
export var title = "CodeBlock-module--title--Fy1iQ";
export var titleBar = "CodeBlock-module--titleBar--Ulv1i";
export var toolbarItem = "CodeBlock-module--toolbarItem--3ebEu";
export var zoom = "CodeBlock-module--zoom--NdxUx";